import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "animate-fade-in relative inline-flex items-center rounded-full px-3 py-1 text-sm text-gray-500 dark:text-gray-300 ring-1 ring-gray-900/10 dark:ring-white/10 hover:ring-gray-900/20 dark:hover:ring-white/20" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "hover:underline" }




export default /*@__PURE__*/_defineComponent({
  __name: 'UiTag',
  props: {
    href: {},
    linkText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.href,
          class: "ml-2 font-semibold whitespace-nowrap text-primary"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "absolute",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.linkText), 1),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _cache[2] || (_cache[2] = _createElementVNode("span", {
            class: "ml-2",
            "aria-hidden": "true"
          }, "→", -1))
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})